import React, { StrictMode } from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { initializeApp } from 'firebase/app';
import Root from 'components/Root/Root';
import { firebaseConfig } from 'constants/firebase';
import store from 'redux/store';
import { firebaseRegistration } from 'utils/firebase';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

initializeApp(firebaseConfig);

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <Root />
    </Provider>
  </StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker
serviceWorkerRegistration.register({
  onSuccess: firebaseRegistration,
  onUpdate: firebaseRegistration,
});
